const getRuntimeDefaultTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export default getRuntimeDefaultTimeZone;
